export enum EScreenMode {
	undefined = 0,
	view = 1,
	edit = 2,
	loading = 4,
	delete = 8,
	new = 16,
	details = 32,
	manageEmployees = 64,
	newEmployee = 128,
	editEmployee = 256,
}

export enum ERoleRight {
	undefined = 0,
	visible = 1,
	editable = 2,

	reserved1 = 4,
	reserved2 = 8,

	appUi = 16,
	appBo = 32,

	reserved3 = 64,
	reserved4 = 128,

	posVb = 256,
	posVl = 512,
	roleSm = 1024,
	roleUm = 2048,
}

export enum EFraudRules {
	/* prio 0 -> old process no mtan no mask - if login fails we are done*/
	Undefiend = 0,
	/* if set canlogin and block will occure */
	Block = 1,
	/* prio 4 -> 2 - 16 pw mask (skip mtan warning)*/
	Vf = 2,
	Vfb = 4,
	Otelo = 8,
	Dsl = 16,

	/// <summary>
	/// will be used in a case where the tan will be sent and validate by extenral API.
	/// </summary>
	TanExternal = 32,
	/* prio 3 ->
	 * mtan required -> passwrod + mtan (default mtan warning)
	 */
	MtanVodafone = 128,
	MtanOtelo = 256,
	MtanVodafoneBusiness = 512,
	/* repalces CustomerAuthMTan - not needed (MTanMandatory = 1024)*/
	/* prio 2 replaces CustomerLoginNoPass - but with mtan (default mtan warning) no skip option*/
	NoPass = 2048,
	/*
	 * service pin highets prio, no possible switch to mtan etc.
	 */
	ServicePin = 4096,
	// It will be used for query the user in the BO.
	// 2024-08-29 sm: bulshit removed
	// BOUsers = 2080,
	/* prio 5 -> replaces role LightMaster - driect login - no pass no mtan*/
	Skip = 65536,
}
